angular.module("vgresiduos").controller("VertownNotificationCreateCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/comunicados-vertown/novo`);
		};
	}
]);
